import { defineMessages } from 'react-intl';

export default defineMessages({
    underlyingPolicyTypeUppercase: {
        id: 'ml.gateway.common.mlMinimumUnderlyingLimit.UNDERLYING POLICY TYPE',
        defaultMessage: 'UNDERLYING POLICY TYPE'
    },
    eachPersonOcurrenceSingleLimitUppercase: {
        id: 'ml.gateway.common.mlMinimumUnderlyingLimit.EACH PERSON / EACH OCCURRENCE OR SINGLE LIMIT',
        defaultMessage: 'EACH PERSON / EACH OCCURRENCE OR SINGLE LIMIT'
    },
    CSL: {
        id: 'ml.gateway.common.mlMinimumUnderlyingLimit.CSL',
        defaultMessage: ' CSL'
    },
});
